import Vue from 'vue'
import Toast, { TYPE } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
    transition: 'Vue-Toastification__fade',
    maxToasts: 20,
    newestOnTop: true,
    toastDefaults: {
        [TYPE.SUCCESS]: {
        },
        [TYPE.ERROR]: {
            position: 'bottom-right',
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: !true,
            closeButton: 'button',
            icon: true,
            rtl: false,
        },
    },
})
